import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FormInput } from "../../components/FormInput";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { checkDpSuccess, getCompanyType, getFormErrorMessage } from "../../utility/service/tool-service";
import { MessageContext,handleSuccessMessage } from "../../store/messageStore";
import { queryCompaniesInfo } from "../../utility/service/company-service";
import { queryIndustryList } from "../../utility/service/register-service";
import { SystemLoading,checkLoading } from "../../store/loadingStore";
import { createInviteRecords, updateInviteRecords,B1010203Before } from "../../utility/service/invite-service";
import { addFormValidator } from "../../utility/validate/formValidator";

export default function InviteRecord_Create(){

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { itemObj,setItemObj,action,setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [detailObj,setDetailObj] = useState({});
    const [, dispatch] = useContext(MessageContext); //訊息視窗  
    const [,loading] = useContext(SystemLoading);
    const [editAction,setEditAction] = useState('detail');//設定目前的動作
    const [ industryList,setIndustryList] = useState([]);
    const [formRule, setFormRule] = useState([]); //表單驗證


    const useTypeList = [
        {
            label:t('company.a'),value:"A"
        },
        {
            label:t('company.b'),value:"B"
        }
    ]
 
    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
            name:'',
            useTypes: []
        },
        //錯誤驗證時機
        mode: "all"
      });


    const getLabelByValue=(value) =>{
        const item = useTypeList?.find(item => item.value === value);
        return item ? item.label : null;
    }

    const btnBackTo = ()=>{
        navigate(`/management/inviteRecord`);
    }

    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }

    const onSubmit = (data) => {
       let reqBody = {
        // companySeq:detailObj?.companySeq,
        type:data.type,
        taxIdNum:data.taxIdNum,
        companyName:data.companyName,
        industryCode:data.industryCode,
        address:data.address,
        leader:data.leader,
        email:data.email,
        userName:data.userName,
        phone:data.phone,
        userEmail:data.userEmail,
        type:data.type
       }
       if(action==='create'){
        createInviteRecords(reqBody)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    handleSuccessMessage(dispatch, t('button.create') + ' ' + t('message.success'));
                    btnBackTo();
                    
                }
            })
       }else if(action === 'update'){
        updateInviteRecords(reqBody)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    console.log(res);
                    
                }
            })
       }
       
      }

        //建立前查詢form 規則
  const axios_getCreateBefore = ()=>{
    B1010203Before()
      .then((res)=>{
          if(checkDpSuccess(res)){
              let array = []
              res?.data?.RespBody?.constraints?.forEach((item) => {
                  const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                  array.push(result)
              })
              setFormRule(array);
          }
      })
}

const setValidForm = useCallback((formId) => {
    if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
            return Object.keys(item)[0] === formId
        });
        return tmp ? tmp[formId] : '';
    }
}, [formRule]);


    useEffect(()=>{
        if((action)!==''){
            setEditAction(action);
            axios_queryIndustryList();
            if(action==='create'){
                setValue("type","A");
                axios_getCreateBefore();
            }
        }else{
            btnBackTo();
        }
    },[action])

    const axios_queryCompaniesInfo = ()=>{
        checkLoading(loading);
        queryCompaniesInfo({companySeq:itemObj?.companySeq})
            .then((res)=>{
                let data = res?.data?.RespBody;
                setDetailObj(data);
                setValue("name",data?.name, { shouldValidate: true });
                setValue("industryCode",data?.industryCode, { shouldValidate: true });
                setValue("status",data?.status, { shouldValidate: true });
                setValue("leader",data?.leader, { shouldValidate: true });
                setValue("email",data?.email, { shouldValidate: true });
                setValue("address",data?.address, { shouldValidate: true });

                clearErrors();

            }).finally((fin)=>{checkLoading(loading,false);})
    }

    const axios_queryIndustryList = ()=>{ //取得行業別下拉清單
        queryIndustryList()
            .then((res)=>{
                if(checkDpSuccess(res)){
                    let data = res.data.RespBody?.industryList;
                    setIndustryList(data);
                }
            })
    }


    return (
    <>
    {/* 返回上頁 */}
    <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
            <Button rounded text onClick={() => { btnBackTo(); }}>
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t('button.return_to_list')}
            </Button>
        </div>
    </div>
    <div className="p-card">
        <div className="p-card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid">
                {/*統一編號*/}
                <div className='col-12 lg:col-3'>
                    {/* <label
                        className="form-label">
                        {t("company_num")}
                    </label>
                    <span>{detailObj?.taxIdNum}</span> */}
                    <FormInput
                        register={register}
                        errors={errors}
                        id="taxIdNum"
                        type="text"
                        labelClass={`control-label ${editAction!=='detail'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={t('company_num')}
                        rules={setValidForm("taxIdNum")}
                    />
                </div>
                {/*組織名稱*/}
                <div className='col-12 lg:col-3'>
                <FormInput
                        register={register}
                        errors={errors}
                        id="companyName"
                        type="text"
                        labelClass={`control-label ${editAction!=='detail'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={t('org_name')}
                        disabled={editAction==='detail'}
                        rules={setValidForm("companyName")}
                    />
                </div>
                {/* 行業代碼 */}
                <div className='col-12 lg:col-3'>
                <label
                htmlFor="industryCode"
                className={`form-label ${editAction==='update' || editAction==='create'?'required':''}`}>
                {t('industry')}
            </label>
                <Controller
                    name="industryCode"
                    control={control}
                    rules={setValidForm("industryCode")}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            disabled={editAction==='detail'}
                            filter
                            optionLabel="industryName"
                            optionValue="industryCode"
                            value={field.value}
                            virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="industryCode"
                            control={control}
                            options={industryList}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                            }}
                        />
                    )}
                />
              {getFormErrorMessage(errors, "industryCode")}
                </div>
                {/* 身分別 */}
                <div className='col-12 lg:col-3'>
                <label
                htmlFor="type"
                className={`form-label ${editAction==='update' || editAction==='create'?'required':''}`}>
                {t('useType')}
            </label>
                <Controller
                    name="type"
                    control={control}
                    rules={setValidForm("type")}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            disabled={editAction==='detail' || getCompanyType()==='A' || getCompanyType()==='B' }
                            filter
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="type"
                            control={control}
                            options={useTypeList}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                            }}
                        />
                    )}
                />
              {getFormErrorMessage(errors, "industryCode")}
                </div>

            </div>
            <div className="grid my-1">
                <div className="col-12 lg:col-3">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="leader"
                        type="text"
                        labelClass={`control-label ${editAction==='update' || editAction==='create'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={t('companyLeader')}
                        disabled={editAction==='detail'}
                        rules={setValidForm("leader")}
                    />
                </div>
                <div className="col-12 lg:col-3">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="email"
                        type="text"
                        labelClass={`control-label ${editAction==='update' || editAction==='create'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={`${t('company.a')} ${t('companyEamil')}`}
                        disabled={editAction==='detail'}
                        rules={setValidForm("email")}
                    />
                </div>
                <div className="col-12 lg:col-6">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="address"
                        type="text"
                        labelClass="control-label"
                        enterClick={checkKeyDown}
                        labelText={t('address')}
                        disabled={editAction==='detail'}
                        rules={setValidForm("address")}                        
                    />
                </div>
            </div>           
            <div className="grid my-1">
            <div className="col-12 lg:col-3">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="userName"
                        type="text"
                        labelClass={`control-label ${editAction==='update' || editAction==='create'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={t('user_name')}
                        disabled={editAction==='detail'}
                        rules={setValidForm("userName")}
                    />
                </div>
                <div className="col-12 lg:col-3">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="phone"
                        type="text"
                        labelClass={`control-label ${editAction==='update' || editAction==='create'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={t('tel')}
                        disabled={editAction==='detail'}
                        rules={setValidForm("phone")}
                    />
                </div>  
                <div className="col-12 lg:col-6">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="userEmail"
                        type="email"
                        labelClass={`control-label ${editAction==='update' || editAction==='create'?'required':''}`}
                        enterClick={checkKeyDown}
                        labelText={t('user_email')}
                        disabled={editAction==='detail'}
                        rules={setValidForm("userEmail")}
                    />
                </div>    
               
            </div>
            <div className="grid">
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("invitationCode")}
                    </label>
                    <span>{detailObj?.inviteCode}</span>
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("inviValidDate")}
                    </label>
                    <span>{detailObj?.inviteEndDate}</span>
                        
                </div>

            </div>
            <div className="col-12 gap-2 flex-all-center">
              {
                ( editAction === 'detail') ?( <div className="col-12 gap-2 flex-all-center">
                    <Button label={t("button.edit")} onClick={(e) => {
                        e.preventDefault();
                        setEditAction('update');
                    }} type="button" size="small" />
                </div>):(<>
                    <Button disabled={action==='create'?!(isValid && isDirty):!isValid} type="submit" label={t("button.confirm")} size="small" />
                    <Button outlined size="small" type="button" label={t("button.cancel")} onClick={(e) => {
                         btnBackTo();
                    }} />
                </>)
              }
            </div>
            </form>
          
        </div>
    </div>
    </>
    )
}